export default __webpack_public_path__ + "static/appBadgePaperless-2ba241eef901241735b2b13ee593d9e3.png";